import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {Button, Dialog} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// dialog
Vue.component(Button.name, Button);
Vue.component(Dialog.name, Dialog);
Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.path == '/' || to.path == '/login') {
        next()
    } else {
        let token = localStorage.getItem('token');
        token ? next() : next('/login');
    }
});

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
